// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14dw_","field":"styles_field__wa4R_","fieldCol":"styles_fieldCol__UPvom","diffCol":"styles_diffCol__KrUiv","diff":"styles_diff__37H54"};